export default __webpack_public_path__ + "static/media/Icons-47.88d67fd4.png";